<template>
    <form @submit.prevent="handleSubmit(item)">
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
            <label for="_name" class="control-label">Name</label>
            <input v-model="item.name" type="text" placeholder="the name of the cookiepreset" required="true" id="_name"
                   class="form-control"/>
            <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.description) }">
            <label for="_description" class="control-label">Description</label>
            <input v-model="item.description" type="text" placeholder="a description of the cookiepreset"
                   id="_description" class="form-control"/>
            <span v-if="errors && errors.description" class="help-block" id="_description_helpBlock">{{ errors.description }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.cookies) }">
            <label for="_cookies" class="control-label">Cookies</label>
            <select v-model="item.cookies" multiple id="_cookies" class="form-control">
                <option v-for="(value, key, index) in cookies" :value="value['@id']">{{value.name}}</option>
            </select>

            <span v-if="errors && errors.cookies" class="help-block" id="_cookies_helpBlock">{{ errors.cookies }}</span>
        </div>

        <button type="submit" class="btn btn-primary">Submit</button>
    </form>
</template>

<script>


    export default {
        props: {
            handleSubmit: {
                type: Function,
                required: true,
            },
            values: {
                type: Object,
                required: true
            },
            errors: {
                type: Object
            },
            initialValues: {
                type: Object
            }
        },
        computed: {
            item: function () {
                let values = this.initialValues ? this.initialValues : this.values;

                return values;
            }
        },
        data: function () {

            return {
                cookies:this.$store.getters['cookies/list/items']
            }
        },

        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$store.subscribe(mutuation => {

                    if (mutuation.type === "cookie/list/COOKIE_LIST_SUCCESS") {
                        this.cookies = Object.assign({}, this.$store.getters['cookie/list/items']);
                    }

                });
                this.$store.dispatch('cookie/list/getItems','/cookies?pagination=false');
            }
        }


    }
</script>



// WEBPACK FOOTER //
// src/components/cookiepreset/Form.vue